@if (newThemeEnabled() && currentPunctuation === '!') {
<span class="bars" aria-hidden="true">
  @for (bar of bars; track bar) {
  <span
    class="bar"
    [class.filled]="bar <= (currentNumberOfPunctuation ?? 0)"
  ></span>
  }
</span>
} @else { @for (number of [].constructor(currentNumberOfPunctuation); track
number) {
<mat-icon class="punctuation" [svgIcon]="icon!"></mat-icon>
} }
<span class="text" [style.color]="currentColor || 'black'">{{
  currentText
}}</span>
